import React from "react"
import { connect } from "react-redux"
import { Button, Row, Col, Card, CardBody } from "reactstrap"

const KYCCheck = (props) => {
    const { validationStatus } = props
    if (validationStatus === "Validated") {
        return (
            <div style={{ overflow: "auto" }}>
                
            </div>
        )
    } else {
        return (
            <Row>
                <Col xs="12">
                    <Card>
                        <CardBody>
                            <h4>Your wallet has not been validated</h4>
                            Here are some of the most common issues:
                            <ul>
                                <li>You have not connected your wallet</li>
                                <li>Different wallet when you minted your NFT</li>
                            </ul>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        )
    }
}
const mapStateToProps = (state) => ({
    networkOptionStatus: state.commonReducer.networkOptionStatus,
    validationStatus: state.commonReducer.validationStatus
})

export default connect(mapStateToProps)(KYCCheck)
